import { render, staticRenderFns } from "./FormZone.vue?vue&type=template&id=dfc577ba&scoped=true"
import script from "./FormZone.vue?vue&type=script&lang=js"
export * from "./FormZone.vue?vue&type=script&lang=js"
import style0 from "./FormZone.vue?vue&type=style&index=0&id=dfc577ba&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfc577ba",
  null
  
)

export default component.exports